import { Grid, Link, Typography } from '@mui/material';
import { PrimaryButton } from '@components/buttons';
import WCTTextField from '@components/input/text-field';
import useForgotPassword from '@pages/auth/forgot-password-hook';
import { useState } from 'react';
import { PageAlertDisplay, SuccessAlert } from '@components/alerts';
import { useAuthTr } from '@i18n/use-auth-tr';
import { Gap } from '@components/layout-util-components/gap';

export default function ForgotPasswordPage() {
  const { email, submit, canSubmit, isLoading } = useForgotPassword();

  const { t } = useAuthTr('forgotPassword');

  const [showSuccess, setShowSuccess] = useState(false);

  const onSubmit = async () => {
    if (await submit()) {
      setShowSuccess(true);
    }
  };

  return (
    <Grid
      container
      component="form"
      noValidate
      direction="column"
      gap={2}
      justifyContent="center"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <Typography variant="h4">{t('title')}</Typography>
      <Gap size={2} />
      {showSuccess ? (
        <>
          <Gap size={2} />
          <SuccessAlert
            title={t('alerts.sent.title')}
            message={t('alerts.sent.message')}
          />
          <Gap size={2} />
        </>
      ) : (
        <>
          <Typography variant="body1">{t('message')}</Typography>
          <Gap size={2} />
          <PageAlertDisplay />
          <WCTTextField
            label={t('email')}
            value={email.value}
            error={email.error}
            onChange={email.set}
            required
          />

          <PrimaryButton type="submit" disabled={!canSubmit} isBusy={isLoading}>
            {t('buttonLabel')}
          </PrimaryButton>
        </>
      )}
      <Grid item alignSelf="center">
        <Typography variant="body1">
          <Link href="../login">{t('backButtonLabel')}</Link>
        </Typography>
      </Grid>
    </Grid>
  );
}
